import {Injectable} from '@angular/core';

// This service listens for scroll events and notifies registered listeners globally.
// Previously, scroll event handling was done individually within specific components.
// However, with 100+ components listening to scroll events, performance issues arose—
// particularly affecting measurements. This global service centralizes scroll handling to improve performance.

@Injectable({ providedIn:'root' })
export class OnScrollService {
  onScrollListeners: OnScroll[] = [];

  constructor() {
    window.addEventListener('scroll', () => {
      this.onWindowScroll();
    });
  }

  onWindowScroll(): void {
      this.onScrollListeners.forEach(listener => {
        if (listener && typeof listener.onWindowScroll === 'function') {
          listener.onWindowScroll();
        }
      });
  }

  addOnScrollListener(onScroll: OnScroll): void {
    this.onScrollListeners.push(onScroll);
  }

  removeOnScrollListener(onScroll: OnScroll): void {
    this.onScrollListeners = this.onScrollListeners.filter(listener => listener !== onScroll);
  }
}

export interface OnScroll {
  onWindowScroll(): void;
}
